import { render, staticRenderFns } from "./UiDetailListItem.vue?vue&type=template&id=52dd69a0&scoped=true&"
import script from "./UiDetailListItem.vue?vue&type=script&lang=js&"
export * from "./UiDetailListItem.vue?vue&type=script&lang=js&"
import style0 from "./UiDetailListItem.vue?vue&type=style&index=0&id=52dd69a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd69a0",
  null
  
)

export default component.exports